import api from "../axios";

// 1. 일자별 하도급/시공계약 amount 데이터
export async function getContractTypeAmount(projectId) {
  const res = await api.get(`contract/bill/contract_type_amount/${projectId}/`);
  return res.data;
}

// 2. construction_type별 amount 데이터
export async function getConstructionTypeAmount(projectId) {
  const res = await api.get(
    `contract/bill/construction_type_amount/${projectId}/`
  );
  return res.data;
}

// 3. construction_type + company별 amount 데이터
export async function getCompanyAmount(projectId) {
  const res = await api.get(`contract/bill/company_amount/${projectId}/`);
  return res.data;
}

// 4. construction_type + 날짜 + 회사별 총 금액 데이터
export async function getAllContracts(projectId) {
  const res = await api.get(`contract/bill/all_contracts/${projectId}/`);
  return res.data;
}
